import { IPermissions } from 'common/permissions.types';
import { EAnalyticsState } from 'constants/navigation';
import { permissionsUtil } from 'utils/permissionsUtil';

const analyticsViewTabs: EAnalyticsState[] = [
  EAnalyticsState.BUSINESS,
  EAnalyticsState.FINANCE,
  EAnalyticsState.AB_TEST
];

export const isSlaPageVisibleForUserRole = ({
  isSlaFeatureFlagEnabled,
  isSuperAdmin
}: {
  isSlaFeatureFlagEnabled: boolean;
  isSuperAdmin: boolean;
}): boolean => {
  if (isSuperAdmin) {
    return true;
  }
  return isSlaFeatureFlagEnabled;
};

export const getAccessibleAnalyticsTabs = (
  permissions: IPermissions,
  projectId: string,
  isSlaPageEnabled: boolean
): EAnalyticsState[] => {
  const accessibleTabs: EAnalyticsState[] = [];

  if (permissionsUtil.canAccessAnalytics(permissions, projectId)) {
    accessibleTabs.push(...analyticsViewTabs);
  }

  if (
    isSlaPageEnabled &&
    permissionsUtil.canAccessApiPerformance(permissions, projectId)
  ) {
    accessibleTabs.push(EAnalyticsState.API_PERFORMANCE);
  }

  return accessibleTabs;
};

export const getDefaultAnalyticsTab = (
  permissions: IPermissions,
  projectId: string,
  isSlaPageEnabled: boolean
): EAnalyticsState => {
  const [firstAccessibleTab] = getAccessibleAnalyticsTabs(
    permissions,
    projectId,
    isSlaPageEnabled
  );
  return firstAccessibleTab ?? EAnalyticsState.BUSINESS;
};
